import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { skipDeviceRedirectState } from "src/recoil/skipDeviceRedirect/atom";

type Props = {
  path: string;
};
const ViewPC = ({ path }: Props) => {
  const navigate = useNavigate();
  const [, setSkipRedirect] = useRecoilState(skipDeviceRedirectState);
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setSkipRedirect(true);
    navigate(path);
  };
  return (
    <div className="view-pc">
      <button onClick={handleClick} className="only-text-btn text-blue text-underline">
        PC버전으로 보기
      </button>
    </div>
  );
};

export default ViewPC;
